const state = {

    exchngRequest: null,
    exchngResponse: [],
    saveExchngRequest: null,
    saveExchngResponse: [],

};

const getters = {
    GET_EXCHANGE_RATE_REQUEST: (state) => {
        return state.exchngRequest;
    },
    GET_EXCHANGE_RATE_RESPONSE: (state) => {
        return state.exchngRes;
    }

};


const actions = {

    CLEAR_EXCHANGE_RATE_STORE: ({ commit }) => {
        commit('clearExchangeRateStore');
    },
    SET_EXCHANGE_RATE_REQUEST: ({ commit }, exchngReq) => {

        commit('storeExchangeRateRequest', exchngReq);

    },

    SET_EXCHANGE_RATE_RESPONSE: ({ commit }, exchngRes) => {
        commit('storeExchangeRateResponse', exchngRes);
    },
    SET_SAVE_EXCHANGE_RATE_REQUEST: ({ commit }, exchngReq) => {

        commit('storeSaveExchangeRateRequest', exchngReq);

    },

    SET_SAVE_EXCHANGE_RATE_RESPONSE: ({ commit }, exchngRes) => {
        commit('storeSaveExchangeRateResponse', exchngRes);
    },

};


const mutations = {
    clearExchangeRateStore: (state) => {
        state.exchngRes = null;
        state.exchngRequest = [];
        state.saveExchngResponse - null;
        state.saveExchngRequest = [];
    },

    storeExchangeRateRequest: (state, exchngReq) => {
        state.exchngRequest = exchngReq;
    },
    storeExchangeRateResponse: (state, exchngRes) => {

        state.exchngResponse = [];
        state.exchngResponse = exchngRes;

    },
    storeSaveExchangeRateRequest: (state, exchngReq) => {
        state.saveExchngRequest = exchngReq;
    },
    storeSaveExchangeRateResponse: (state, exchngRes) => {

        state.saveExchngResponse = [];
        state.saveExchngResponse = exchngRes;

    },




};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}